window.Backbone = require 'backbone'
window.Backbone.$ = window.$
FAQ = require('../../modules/faq/frontend/faq')
